export default "__VITE_PUBLIC_ASSET__62b18d09__"